export const GET_DOCUSIGN_ENVELOPES = "GET_DOCUSIGN_ENVELOPES";
export const GET_DOCUSIGN_ENVELOPES_SUCCESS = "GET_DOCUSIGN_ENVELOPES_SUCCESS";
export const GET_DOCUSIGN_ENVELOPES_FAILURE = "GET_DOCUSIGN_ENVELOPES_FAILURE";
export const GET_DOCUSIGN_ENVELOPES_RESET = "GET_DOCUSIGN_ENVELOPES_RESET";

export const ADD_DOCUSIGN_ENVELOPE = "ADD_DOCUSIGN_ENVELOPE";
export const ADD_DOCUSIGN_ENVELOPE_SUCCESS = "ADD_DOCUSIGN_ENVELOPE_SUCCESS";
export const ADD_DOCUSIGN_ENVELOPE_FAILURE = "ADD_DOCUSIGN_ENVELOPE_FAILURE";
export const ADD_DOCUSIGN_ENVELOPE_RESET = "ADD_DOCUSIGN_ENVELOPE_RESET";
